import { useHistory } from 'react-router-dom';
import { useAuth } from '../../contexts/UserContext';
import { IconArrowLeft } from '../icons';
import { Container } from './styles';

interface Props {
    title?: string;
    type?: string;
    subtitle?: string;
    /** Quando true, renderiza o layout de Planos (título + subtítulo + div para botões) mesmo antes do pageName ser atualizado no contexto */
    isPlanosRoute?: boolean;
}

export default function Header({ title, type, subtitle, isPlanosRoute }: Props) {
  const history = useHistory();
  const { pageName } = useAuth();

  const isPlanos = pageName === 'Planos' || isPlanosRoute;

  return (
    <Container pageType={type} className={isPlanos ? 'header-with-actions' : ''}>
      {
        pageName !== 'Propostas' &&
        pageName !== 'Profissionais' &&
        pageName !== 'Operadores' &&
        pageName !== 'Demandas' &&
        pageName !== 'Visão geral' &&
        pageName !== 'Financeiro' &&
        pageName !== 'Notificações' &&
        pageName !== 'Solicitantes' &&
        pageName !== 'Planos' &&

          <div
          className='back'
          onClick={() => {
            if (window.history.length > 1) {
              history.goBack();
            } else {
              history.push('/demandas');
            }
          }}
        >
          <IconArrowLeft />
          Voltar
        </div>
      }
      {isPlanos ? (
        <>
          <div className="header-title-block">
            <h1>{title ?? 'Visão geral'}</h1>
            {subtitle && <p className="header-subtitle">{subtitle}</p>}
          </div>
          <div id="planos-header-actions" />
        </>
      ) : (
        <h1>{title ?? 'Visão geral'}</h1>
      )}
    </Container>
  )
}
